import React from "react";
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import TenderProcessTracker from "../../components/TenderProcessTracker/TenderProcessTracker";
import { useParams } from "react-router-dom";
import { FinalizedSummary }  from "../../components/TenderProcess"
import {
    FinalizedSummaryPageContainer,
} from "./FinalizedSummaryPage.styles";

export default function FinalizedSummaryPage() {
    const { tenderId, subStep } = useParams();
    return (
        <FinalizedSummaryPageContainer data-testid="main-content">
            <Breadcrumbs />
            <TenderProcessTracker />
            <FinalizedSummary tenderId={tenderId} subStep={subStep}/>
        </FinalizedSummaryPageContainer>
    );
}